import { render, staticRenderFns } from "./Commission.vue?vue&type=template&id=1964fe32&scoped=true&"
import script from "./Commission.vue?vue&type=script&lang=ts&"
export * from "./Commission.vue?vue&type=script&lang=ts&"
import style0 from "./Commission.vue?vue&type=style&index=0&id=1964fe32&prod&lang=css&"
import style1 from "./Commission.vue?vue&type=style&index=1&id=1964fe32&prod&lang=scss&"
import style2 from "./Commission.vue?vue&type=style&index=2&id=1964fe32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1964fe32",
  null
  
)

export default component.exports